import { ICONS } from '@app/constants';
import type { NConstants, NUtils } from '@app/types';

const defaultData = {
  code: '',
  color: '',
};

export const getIconObjectById: NUtils.GetIconObjectById = (id, options) => {
  const icon = ICONS.find((icon) => icon.id === id);
  if (options) {
    return { ...icon, ...options } as NConstants.IconObject; // to set a custom color or size
  }
  return (icon as NConstants.IconObject) || defaultData;
};
